(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-tr1-lp-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('sb-tr1-countdown')) return;

    class SbTr1Countdown extends HTMLElement {
      connectedCallback() {
        var minutes = parseInt(this.dataset.durationMinutes, 10);
        if (isNaN(minutes) || minutes <= 0) return;

        this.durationMs = minutes * 60 * 1000;
        this.storageKey = this.dataset.storageKey || 'sb_tr1_countdown_expiry';

        var now = Date.now();
        var stored = null;
        try {
          stored = window.sessionStorage.getItem(this.storageKey);
        } catch (e) {
          // sessionStorage unavailable (privacy mode etc). Fall back to a
          // page-load-only countdown so the bar still renders correctly.
        }

        var expiry = stored ? parseInt(stored, 10) : NaN;
        if (isNaN(expiry) || expiry <= now) {
          expiry = now + this.durationMs;
          try {
            window.sessionStorage.setItem(this.storageKey, String(expiry));
          } catch (e) {
            // ignore, this instance just will not persist across reloads
          }
        }

        this.expiry = expiry;
        this.hrsEl = this.querySelector('[data-hrs]');
        this.minEl = this.querySelector('[data-min]');
        this.secEl = this.querySelector('[data-sec]');

        this.tick();
        this.interval = window.setInterval(this.tick.bind(this), 1000);
      }

      disconnectedCallback() {
        if (this.interval) window.clearInterval(this.interval);
      }

      tick() {
        var remaining = Math.max(0, this.expiry - Date.now());
        var totalSeconds = Math.floor(remaining / 1000);
        var hrs = Math.floor(totalSeconds / 3600);
        var min = Math.floor((totalSeconds % 3600) / 60);
        var sec = totalSeconds % 60;

        if (this.hrsEl) this.hrsEl.textContent = String(hrs).padStart(2, '0');
        if (this.minEl) this.minEl.textContent = String(min).padStart(2, '0');
        if (this.secEl) this.secEl.textContent = String(sec).padStart(2, '0');

        if (remaining <= 0 && this.interval) window.clearInterval(this.interval);
      }
    }

    customElements.define('sb-tr1-countdown', SbTr1Countdown);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-tr1-lp-reasons"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('sb-tr1-lazy-video')) return;

    class SbTr1LazyVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        // Real lazyload: nothing plays until the video scrolls near the
        // viewport, then it starts (muted, so autoplay is allowed) and loops.
        this.observer = new IntersectionObserver(
          this.onIntersect.bind(this),
          { rootMargin: '200px 0px' }
        );
        this.observer.observe(this);
      }

      onIntersect(entries) {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          var playPromise = this.video.play();
          if (playPromise && playPromise.catch) playPromise.catch(function () {});
          this.observer.unobserve(this);
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }

    customElements.define('sb-tr1-lazy-video', SbTr1LazyVideo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-tr1-nad-story"]) return;
  try {
    
  (function () {
    'use strict';

    var CONFETTI_COLORS = ['#f2692d', '#da6d00', '#cac8c5', '#010101', '#fcf2e8'];

    function reducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function Tr1NadStory(root) {
      this.root = root;
      this.steps = Array.prototype.slice.call(root.querySelectorAll('[data-tns-step]'));
      this.segs = Array.prototype.slice.call(root.querySelectorAll('[data-tns-seg]'));
      this.back = root.querySelector('[data-tns-back]');
      this.skip = root.querySelector('[data-tns-skip]');
      this.offer = parseInt(root.getAttribute('data-offer'), 10);
      if (isNaN(this.offer) || this.offer < 0) this.offer = this.steps.length - 1;
      this.index = 0;
      if (!this.steps.length) return;
      this.bind();
      this.sync();
      this.preload();
      this.startTimers();
    }

    Tr1NadStory.prototype.track = function (name, extra) {
      if (this.root.getAttribute('data-track') !== 'true') return;
      var detail = Object.assign({ event: name, story: this.root.id }, extra || {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(detail);
      if (typeof window.fbq === 'function') window.fbq('trackCustom', name, extra || {});
    };

    Tr1NadStory.prototype.go = function (to, reason) {
      if (to < 0 || to >= this.steps.length || to === this.index) return;
      var from = this.steps[this.index];
      var next = this.steps[to];
      var motion = !reducedMotion();

      if (reason === 'next') this.track('tns_step_complete', { step: this.index + 1 });

      from.classList.remove('is-active');
      from.setAttribute('aria-hidden', 'true');
      if (motion) {
        from.classList.add('is-leaving');
        window.setTimeout(function () { from.classList.remove('is-leaving'); }, 400);
      }

      this.loadStep(to);
      this.loadStep(to + 1);

      this.playIn(from, false);

      next.removeAttribute('aria-hidden');
      next.classList.add('is-active');
      this.playIn(next, true);
      next.scrollTop = 0;
      this.index = to;
      this.sync();

      var heading = next.querySelector('[data-tns-focus]');
      if (heading && reason !== 'editor') heading.focus({ preventScroll: true });

      if (next.querySelector('[data-tns-confetti]')) this.confetti(next);
    };

    Tr1NadStory.prototype.sync = function () {
      var i = this.index;
      this.segs.forEach(function (seg, n) { seg.classList.toggle('is-done', n <= i); });
      if (this.back) this.back.hidden = i === 0;
      if (this.skip) this.skip.hidden = i >= this.offer;
    };

    Tr1NadStory.prototype.bind = function () {
      var self = this;

      this.root.addEventListener('click', function (event) {
        var next = event.target.closest('[data-tns-next]');
        if (next && self.root.contains(next)) {
          self.go(self.index + 1, 'next');
          return;
        }
        if (event.target.closest('[data-tns-offer]')) self.track('tns_offer_click', { step: self.index + 1 });
      });

      if (this.back) this.back.addEventListener('click', function () { self.go(self.index - 1, 'back'); });
      if (this.skip) {
        this.skip.addEventListener('click', function () {
          self.track('tns_offer_skip', { from_step: self.index + 1 });
          self.go(self.offer, 'skip');
        });
      }

      document.addEventListener('keydown', function (event) {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        var tag = (event.target && event.target.tagName) || '';
        if (/INPUT|TEXTAREA|SELECT/.test(tag)) return;
        if (event.key === 'ArrowLeft') self.go(self.index - 1, 'back');
      });

      // Review rows: the dot follows the card in view.
      Array.prototype.forEach.call(this.root.querySelectorAll('[data-tns-carousel]'), function (row) {
        var dots = Array.prototype.slice.call(row.parentNode.querySelectorAll('[data-tns-dot]'));
        if (!dots.length) return;
        var ticking = false;
        row.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            ticking = false;
            var at = Math.round(row.scrollLeft / (row.clientWidth || 1));
            dots.forEach(function (dot, n) { dot.classList.toggle('is-active', n === at); });
          });
        }, { passive: true });
        dots.forEach(function (dot, n) {
          dot.addEventListener('click', function () {
            row.scrollTo({ left: n * row.clientWidth, behavior: reducedMotion() ? 'auto' : 'smooth' });
          });
        });
      });

      // Theme editor: selecting a block opens its screen.
      document.addEventListener('shopify:block:select', function (event) {
        var id = event.detail && event.detail.blockId;
        self.steps.forEach(function (step, n) {
          if (step.getAttribute('data-block-id') === id) self.go(n, 'editor');
        });
      });
    };

    // Swap a screen's deferred images in. Resolves when they have loaded, or
    // failed, so the queue below can move on to the next screen.
    Tr1NadStory.prototype.loadStep = function (index) {
      var step = this.steps[index];
      if (!step) return Promise.resolve();
      var imgs = Array.prototype.slice.call(step.querySelectorAll('img[data-src]'));
      var videos = Array.prototype.slice.call(step.querySelectorAll('video[data-tns-video]')).filter(function (v) {
        return v.querySelector('source[data-src]');
      });
      var videoLoads = videos.map(function (video) {
        return new Promise(function (done) {
          var settle = function () { done(); };
          video.addEventListener('loadeddata', settle, { once: true });
          video.addEventListener('error', settle, { once: true });
          window.setTimeout(settle, 4000);
          Array.prototype.forEach.call(video.querySelectorAll('source[data-src]'), function (source) {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          });
          video.preload = 'auto';
          video.load();
          if (step.classList.contains('is-active')) {
            var started = video.play();
            if (started && started.catch) started.catch(function () {});
          }
        });
      });
      return Promise.all(videoLoads.concat(imgs.map(function (img) {
        return new Promise(function (done) {
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          img.removeAttribute('data-srcset');
        });
      })));
    };

    // Only the screen on view plays its video; the one being left pauses.
    Tr1NadStory.prototype.playIn = function (step, play) {
      Array.prototype.forEach.call(step.querySelectorAll('video[data-tns-video]'), function (video) {
        if (!play) { video.pause(); return; }
        var started = video.play();
        if (started && started.catch) started.catch(function () {});
      });
    };

    // The first screen's image downloads alone. Once it is in, the rest follow
    // one screen at a time, in order, so the next screen is ready long before
    // anyone taps through to it. The fallback is window load, never a timer: a
    // timer fired while the first image was still coming in on a slow phone
    // and split its bandwidth.
    Tr1NadStory.prototype.preload = function () {
      var self = this;
      var first = this.steps[0] && this.steps[0].querySelector('img');
      var started = false;
      function queue() {
        if (started) return;
        started = true;
        var n = 1;
        (function next() {
          if (n >= self.steps.length) return;
          self.loadStep(n++).then(next);
        })();
      }
      if (!first || first.complete) queue();
      else {
        first.addEventListener('load', queue, { once: true });
        first.addEventListener('error', queue, { once: true });
      }
      if (document.readyState === 'complete') queue();
      else window.addEventListener('load', queue, { once: true });
    };

    Tr1NadStory.prototype.startTimers = function () {
      Array.prototype.forEach.call(this.root.querySelectorAll('[data-tns-timer]'), function (el) {
        var mode = el.getAttribute('data-mode');
        var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 135;
        var key = 'tns-timer-' + el.getAttribute('data-key');
        var hEl = el.querySelector('[data-tns-h]');
        var mEl = el.querySelector('[data-tns-m]');
        var sEl = el.querySelector('[data-tns-s]');

        function endTime() {
          var now = Date.now();
          if (mode === 'midnight') {
            var d = new Date();
            d.setHours(24, 0, 0, 0);
            return d.getTime();
          }
          var stored = null;
          try { stored = parseInt(window.localStorage.getItem(key), 10); } catch (e) {}
          if (!stored || stored <= now) {
            stored = now + minutes * 60000;
            try { window.localStorage.setItem(key, String(stored)); } catch (e) {}
          }
          return stored;
        }

        function pad(n) { return (n < 10 ? '0' : '') + n; }

        var end = endTime();
        function tick() {
          var left = end - Date.now();
          if (left <= 0) {
            end = endTime();
            left = end - Date.now();
          }
          var t = Math.max(0, Math.floor(left / 1000));
          hEl.textContent = pad(Math.floor(t / 3600));
          mEl.textContent = pad(Math.floor((t % 3600) / 60));
          sEl.textContent = pad(t % 60);
        }
        tick();
        window.setInterval(tick, 1000);
      });
    };

    Tr1NadStory.prototype.confetti = function (step) {
      if (reducedMotion()) return;
      var box = step.querySelector('[data-tns-confetti]');
      if (!box) return;
      box.innerHTML = '';
      for (var i = 0; i < 42; i++) {
        var bit = document.createElement('i');
        bit.style.left = Math.random() * 100 + '%';
        bit.style.background = CONFETTI_COLORS[i % CONFETTI_COLORS.length];
        bit.style.setProperty('--drift', (Math.random() * 120 - 60).toFixed(0) + 'px');
        bit.style.setProperty('--spin', (Math.random() * 720 - 360).toFixed(0) + 'deg');
        bit.style.setProperty('--dur', (2.6 + Math.random() * 2.2).toFixed(2) + 's');
        bit.style.setProperty('--delay', (Math.random() * 0.9).toFixed(2) + 's');
        if (i % 3 === 0) bit.style.borderRadius = '50%';
        box.appendChild(bit);
      }
    };

    function boot(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-tns]'), function (root) {
        if (root.hasAttribute('data-tns-ready')) return;
        root.setAttribute('data-tns-ready', 'true');
        new Tr1NadStory(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
